module.exports = __webpack_public_path__ + "img/no-notifications.ce7e8c66.svg";